import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { geoDataServiceUrl } from '../../../../urls'

const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
}

const geoDataInstance = axios.create({
  baseURL: geoDataServiceUrl,
  headers,
})

geoDataInstance.interceptors.request.use(requestInterceptor, error => Promise.reject(error))

geoDataInstance.interceptors.response.use(response => response, error => {
  return responseInterceptor(error)
})

export default geoDataInstance
